import {Component, OnInit} from '@angular/core';
import {FuseConfigService} from '../../../../core/services/config.service';
import {FormControl, FormGroup} from "@angular/forms";
import { PlatformsService } from '../../../../core/services/platforms.service';

@Component({
    selector: 'project-settings',
    templateUrl: './project-set.component.html',
    styleUrls: ['./project-set.component.scss'],
    standalone: false
})

export class ProjectSetComponent implements OnInit{

  form: FormGroup = new FormGroup({
    backendLink: new FormControl(''),
    emailSendFrom: new FormControl(''),
    facebook: new FormControl(''),
    footerEmailData: new FormControl(''),
    imageLink: new FormControl(''),
    instagram: new FormControl(''),
    metaDescription: new FormControl(''),
    oldLink: new FormControl(''),
    pageTitle: new FormControl(''),
    twitter: new FormControl(''),
    websiteInfoLink: new FormControl(''),
    websiteLink: new FormControl(''),
    whatsappFromNumber: new FormControl(''),
    loginImage: new FormControl(''),
    id: new FormControl('')
  });

  mail: FormGroup = new FormGroup({
    host: new FormControl(''),
    name: new FormControl(''),
    port: new FormControl(''),
    secure: new FormControl(''),
    user: new FormControl(''),
    pass: new FormControl('')
  });

  whatsApp: FormGroup = new FormGroup({
    sid: new FormControl(''),
    token: new FormControl('')
  });

  sms: FormGroup = new FormGroup({
    host: new FormControl(''),
    name: new FormControl(''),
    port: new FormControl(''),
    secure: new FormControl(''),
    user: new FormControl(''),
    pass: new FormControl(''),
    sender: new FormControl('')
  });

  edit = false;
  projectData;
  projectDataKeys = [];
  mailData;
  mailKeys = [];
  smsData;
  smsKeys = [];
  whatsAppData;
  whatsAppKeys = [];

  platforms;
  selectedPlatform;
  settingId;
  constructor(public configService: FuseConfigService, private platformsService: PlatformsService) {

  }

  ngOnInit() {
    this.mailKeys = Object.keys(this.mail.value);
    this.mailData = this.mail.value;
    this.smsKeys = Object.keys(this.sms.value);
    this.smsData = this.sms.value;
    this.whatsAppKeys = Object.keys(this.whatsApp.value);
    this.whatsAppData = this.whatsApp.value;
    this.getPlatforms();

  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res && res.length) {
        this.platforms = res;
        this.selectedPlatform = this.platforms[0].id;
        this.getSettings();
      }
    });
  }

  getSettings() {
    this.configService.getProjectSettingsByPlatform(this.selectedPlatform).subscribe((res: any) => {
      if (res) {
        this.settingId = res.id;
        if (res.mail) {
          this.mailData = Object.assign(JSON.parse(res.mail));
          this.mail.patchValue(JSON.parse(res.mail));
        } else {
          this.mail.reset();
          this.mailData = this.mail.value;
        }
        if (res.sms) {
          this.smsData = Object.assign(JSON.parse(res.sms));
          this.sms.patchValue(JSON.parse(res.sms));
        } else {
          this.sms.reset();
          this.smsData = this.sms.value;
        }
        if (res.whatsApp) {
          this.whatsAppData = Object.assign(JSON.parse(res.whatsApp));
          this.whatsApp.patchValue(JSON.parse(res.whatsApp));
        } else {
          this.whatsApp.reset();
          this.whatsAppData = this.whatsApp.value;
        }
        this.projectData = {};
        this.form.patchValue(res);
        this.projectData = Object.assign(res);
        delete res.id;
        delete res.platformId;
        delete res.mail;
        delete res.sms;
        delete res.whatsApp;
        this.projectDataKeys = Object.keys(res);
        this.projectDataKeys.sort();
      } else {
        this.projectData = null;
        this.mailData = null;
        this.smsData = null;
        this.whatsAppData = null;
      }

    });
  }

  changePlatforms(platform) {
    this.selectedPlatform = platform.value;
    this.getSettings();
  }

  editFunc() {
    this.edit = !this.edit;
  }

  save() {
    let data: any = this.form.value;
    data.mail = JSON.stringify(this.mail.value);
    data.sms = JSON.stringify(this.sms.value);
    data.whatsApp = JSON.stringify(this.whatsApp.value);
    data.platformId = this.selectedPlatform;
    data.id = this.settingId;
    this.configService.saveProjectSettings(data).subscribe((res: any) => {
      if (res) {
        this.settingId = res.id;
        if (res.mail) {
          this.mailData = Object.assign(JSON.parse(res.mail));
          this.mail.patchValue(JSON.parse(res.mail));
        } else {
          this.mail.reset();
          this.mailData = this.mail.value;
        }
        if (res.sms) {
          this.smsData = Object.assign(JSON.parse(res.sms));
          this.sms.patchValue(JSON.parse(res.sms));
        } else {
          this.sms.reset();
          this.smsData = this.sms.value;
        }
        if (res.whatsApp) {
          this.whatsAppData = Object.assign(JSON.parse(res.whatsApp));
          this.whatsApp.patchValue(JSON.parse(res.whatsApp));
        } else {
          this.whatsApp.reset();
          this.whatsAppData = this.whatsApp.value;
        }
        this.edit = false;
        this.projectData = Object.assign(res);
        delete res.id;
        delete res.platformId;
        delete res.mail;
        delete res.sms;
        delete res.whatsApp;
        this.projectDataKeys = Object.keys(res);
      } else {
        this.projectData = null;
        this.mailData = null;
        this.smsData = null;
        this.whatsAppData = null;
      }
    });
  }
}
